
import { Contact, Sale } from "@/models/base";
import Vue from "vue";
import { ClientPortalService, ISalePublicUrlResponse } from "@/services/client-portal-service";
import AppInvoiceList from "@/components/client-portal/InvoiceList.vue";
import { ToolbarService } from "@/services/toolbar-service";
import { printHumanFloat } from "@/utils/pretty-print";
import AppSignSaleModal from "@/components/client-portal/SignSaleModal.vue";
import {ClientPortalTabConfig} from "@/models/dossier-configs/client-portal-tab-config";


export default Vue.extend({
	data() {
		return {
			ready: false,
			token: "",
			config: [] as ClientPortalTabConfig[],
			client: null as Contact | null,
			activeSale: undefined as Sale | undefined,
			paidSales: [] as Sale[],
			openSales: [] as Sale[],
			openEstimates: [] as Sale[],
			closedEstimates: [] as Sale[],
			expiredSales: [] as Sale[],
			additionalSales: [] as Sale[],
			selectedSale: null as ISalePublicUrlResponse | null,
			fetching: false,
			openSaleRecords: 0,
			paidSaleRecords: 0,
			canPayWithMollie: false,
			showEstimates: false,
			signModalOpen: false,
			toSignSale: undefined as Sale | undefined,
			singleSaleToken: "",
			headerInfo: "",
			SignableTypes: [] as String[]
		};
	},
	computed: {
		name(): string {
			return this.client == null ? "" : this.client.getPersonalName();
		},
		title(): string {
			return this.$ct("client-portal").toString() + (this.client !== null ? " " + this.client.getDisplayName() : "");
		},
		compactLayout(): boolean {
			return this.$wf.isMdDown;
		},
		showTotalOpen(): boolean {
			let o = this.openSales.reduce((sum, current) => sum + current.TotalOpen, 0);
			let a = this.expiredSales.reduce((sum, current) => sum + current.TotalOpen, 0);
			return o>0 || a>0;
		},
		totalOpen(): string {
			let o = this.openSales.reduce((sum, current) => sum + current.TotalOpen, 0);
			let a = this.expiredSales.reduce((sum, current) => sum + current.TotalOpen, 0);
			return printHumanFloat(a+o, 2);
		},
		activeInvoices():Sale[]{
			if (this.activeSale) {
				return [this.activeSale];
			}
			return [];
		}
	},
	methods: {
		parseTemplate(template:string, client:Contact) {
			// Parse and replace `{{ if ... }}` logic
			const conditionTemplate = template
				.replace(/{{\s*if\s+(.*?)\s*}}/g, (_, condition) => {
					// Evaluate the condition dynamically
					try {
						return new Function("client", `return ${condition}`)(client) ? "" : "__SKIP__";
					} catch (error) {
						return "__SKIP__";
					}
				})
				.replace(/{{\s*else\s*}}/g, (_, match) => "__ELSE__")
				.replace(/{{\s*end\s*}}/g, "");

			// Handle skipped blocks and replace placeholders
			let skip = false;
			const processedTemplate = conditionTemplate
				.split("\n")
				.map((line) => {
					if (line.includes("__SKIP__")) {
						skip = true;
						return "";
					}
					if (line.includes("__ELSE__")) {
						skip = !skip;
						return "";
					}
					return skip ? "" : line;
				})
				.join("\n");

			return processedTemplate.replace(/{{\s*(.*?)\s*}}/g, (_, match) => {
				try {
					return new Function("client", `return ${match}`)(client);
				} catch (error) {
					return "";
				}
			});
		},
		async invoiceClicked(invoice: Sale) {
			this.selectedSale = null;
			let token = await ClientPortalService.getSalePublicToken(this.token, invoice.ID);

			window.open(`/sale-url/${token}`);
			//this.$router.push(`/sale-url/${token}`);

			// TODO: Joris kijk jij dit na?
			/*if (this.compactLayout) {
				this.$router.push(`/sale-url/${token}`);
			} else {
				let publicSale = await ClientPortalService.getSaleFromPublicToken(token);
				this.selectedSale = publicSale;
			}*/
		},
		async showSignModale(){
			if(!this.toSignSale){
				return;
			}
			this.singleSaleToken = await ClientPortalService.getSalePublicToken(this.token, this.toSignSale.ID);
			this.signModalOpen = true;
			return;
		},
		async fetch(){
			this.paidSales = [];
			this.openSales = [];
			await this.fetchData();
		},
		async fetchData() {
			if (this.fetching) return;
			try {
				this.paidSales = [];
				this.openSales = [];
				this.expiredSales = [];
				this.additionalSales = [];
				this.fetching = true;
				let response = await ClientPortalService.getClientPortalData(this.token, this.paidSales.length + this.openSales.length);
				this.config = response.Config;
				this.client = response.Client;
				this.paidSales.push(...response.PaidSales);
				this.openSales.push(...response.OpenSales);
				this.expiredSales.push(...response.ExpiredSales);
				this.additionalSales.push(...response.AdditionalSales);
				this.openSaleRecords = response.OpenSaleRecords;
				this.paidSaleRecords = response.PaidSaleRecords;
				this.canPayWithMollie = response.CanPayWithMollie;
				this.showEstimates = response.ShowEstimates;
				this.headerInfo = response.HeaderInfo;
				this.openEstimates= response.OpenEstimates;
				this.closedEstimates= response.ClosedEstimates;
				this.SignableTypes= response.SignableTypes;
				if (response.HighlightSale) {
					this.activeSale = this.openSales.find(
						sale => sale.ID == response.HighlightSale);
					if (!this.activeSale) {
						this.activeSale = this.paidSales.find(
							sale => sale.ID == response.HighlightSale);
					}
				}

			} catch (err) {

			}
			this.fetching = false;
		},
	},
	async created() {
		this.token = this.$route.params.token;
		await this.fetchData();
		ToolbarService.title = this.title;
		setTimeout(() => this.ready = true, 500);
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();

	}
	,
	components: {
		AppInvoiceList,
		AppSignSaleModal
	}
	,
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
})
;
